import script from "./plantillasForm.vue?vue&type=script&setup=true&lang=js"
export * from "./plantillasForm.vue?vue&type=script&setup=true&lang=js"

import "./plantillasForm.vue?vue&type=style&index=0&id=3e84d844&scoped=true&lang=css"
import "./plantillasForm.vue?vue&type=style&index=1&id=3e84d844&lang=css"
import "./plantillasForm.vue?vue&type=style&index=2&id=3e84d844&lang=css"
import "./plantillasForm.vue?vue&type=style&index=3&id=3e84d844&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e84d844"]])

export default __exports__